// extracted by mini-css-extract-plugin
export default {"Brands":"Brands_Brands__iMHWq","holder":"Brands_holder__Ut1E-","item":"Brands_item__5PYS9","image":"Brands_image__rVOIj"};